'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PopupManager = require('./components/PopupManager.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PopupManager).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-popup-manager/lib/index.js
// module id = 523
// module chunks = 1